import { generateClassName } from "./utils";
import { registerComponent } from "./jquery";
import { mmDropDownButton, mmDropDownButtonOptions } from "@/types";
import Collapsible from "./collapsible";

class DropDownButton extends Collapsible<mmDropDownButtonOptions> implements mmDropDownButton {
  private _dxDropDownButton!: DevExpress.ui.dxDropDownButton;

  constructor(element: HTMLElement, options?: mmDropDownButtonOptions) {
    super(element, options);

    this._dxDropDownButton = $(this._element)
      .dxDropDownButton({
        text: this._options.text,
        icon: this._options.icon,
        elementAttr: {
          class: generateClassName(
            "dropdown-button",
            this._options.color!,
            this._options.size!,
            this._options.shape,
            this._options.className,
          ),
          ...(this._options.attributes ?? {}),
        },
        stylingMode: this._options.style,
        dataSource: this._options.dataSource,
        template: this._options.template,
        splitButton: this._options.splitButton,
        selectedItemKey: this._options.selectedItemKey,
        itemTemplate: this._options.itemTemplate,
        useSelectMode: this._options.useSelectMode,
        dropDownContentTemplate: this._options.dropDownContentTemplate,
        showArrowIcon: this._options.showArrowIcon,
        dropDownOptions: {
          ...this._options.dropDownOptions,
          wrapperAttr: {
            class: generateClassName(
              "dropdown-popup",
              this._options.color == "default" ? "primary" : this._options.color!,
              this._options.size!,
            ),
          },
          width: this._options.dropDownWidth ?? this._options.dropDownOptions?.width,
          minWidth: this._options.dropDownMinWidth ?? this._options.dropDownOptions?.minWidth,
        },
        displayExpr: this._options.displayExpr,
        keyExpr: this._options.keyExpr,
        items: this._options.items,
        onButtonClick: this._onButtonClick,
        onItemClick: this._onItemClick,
        onInitialized: this._onInitialized,
      })
      .dxDropDownButton("instance");
  }

  public getDefaults(): mmDropDownButtonOptions {
    return {
      color: "default",
      size: "md",
      itemTemplate: "item",
      dropDownContentTemplate: "content",
      shape: "normal",
      style: "contained",
    };
  }

  private _onButtonClick = (e: DevExpress.ui.dxDropDownButton.ButtonClickEvent): void => {
    if (this._options.splitButton) {
      this._dxDropDownButton.close();
    }

    if (this._options.onButtonClick) {
      this._options.onButtonClick(e);
    }
  };

  private _onItemClick = (e: DevExpress.ui.dxDropDownButton.ItemClickEvent): void => {
    if (this._options.onItemClick) {
      this._options.onItemClick(e);
    }
  };

  private _onInitialized = (e: DevExpress.ui.dxDropDownButton.InitializedEvent): void => {
    e.element!.on("mousedown", () => {
      e.element!.find(".dx-buttongroup").dxButtonGroup("instance").focus();
    });

    if (this._options.splitButton) {
      e.element!.on("mouseup", () => {
        $(this._element).find(".dx-buttongroup-first-item.dx-state-focused").removeClass("dx-state-focused");
      });
    }
  };
}

registerComponent("mmDropDownButton", DropDownButton);

export default DropDownButton;
